import j6_cover from "../images/cars/j6/cover.webp";
import j7_cover from "../images/cars/j7/cover.webp";
import j8_cover from "../images/cars/j8/cover.webp";
import j7_new_cover from "../images/cars/j7_new/cover.webp";
import jeland_j6_cover from "../images/cars/jeland_j6/cover.webp";
import jeland_j644_cover from "../images/cars/jeland_j6_44/cover.png";
import jeland_j7_cover from "../images/cars/jeland_j7/cover.webp";

import j6_01 from "../images/cars/j6/gallery/01.jpg";
import j6_02 from "../images/cars/j6/gallery/02.jpg";
import j6_03 from "../images/cars/j6/gallery/03.jpg";
import j6_04 from "../images/cars/j6/gallery/04.jpg";
import j6_05 from "../images/cars/j6/gallery/05.jpg";
import j6_06 from "../images/cars/j6/gallery/06.jpg";
import j6_07 from "../images/cars/j6/gallery/07.jpg";
import j6_08 from "../images/cars/j6/gallery/08.jpg";
import j6_09 from "../images/cars/j6/gallery/09.jpg";

import jeland_j6_01 from "../images/cars/jeland_j6/gallery/01.jpg";
import jeland_j6_02 from "../images/cars/jeland_j6/gallery/02.jpg";
import jeland_j6_03 from "../images/cars/jeland_j6/gallery/03.jpg";
import jeland_j6_04 from "../images/cars/jeland_j6/gallery/04.jpg";
import jeland_j6_05 from "../images/cars/jeland_j6/gallery/05.jpg";
import jeland_j6_06 from "../images/cars/jeland_j6/gallery/06.jpg";
import jeland_j6_07 from "../images/cars/jeland_j6/gallery/07.jpg";
import jeland_j6_08 from "../images/cars/jeland_j6/gallery/08.jpg";
import jeland_j6_09 from "../images/cars/jeland_j6/gallery/09.jpg";

import jeland_j644_01 from "../images/cars/jeland_j6_44/gallery/1.jpg";
import jeland_j644_02 from "../images/cars/jeland_j6_44/gallery/2.jpg";
import jeland_j644_03 from "../images/cars/jeland_j6_44/gallery/3.jpg";
import jeland_j644_04 from "../images/cars/jeland_j6_44/gallery/4.jpg";
import jeland_j644_05 from "../images/cars/jeland_j6_44/gallery/5.jpg";
import jeland_j644_06 from "../images/cars/jeland_j6_44/gallery/6.jpg";
import jeland_j644_07 from "../images/cars/jeland_j6_44/gallery/7.jpg";

import jeland_j7_01 from "../images/cars/jeland_j7/gallery/01.jpg";
import jeland_j7_02 from "../images/cars/jeland_j7/gallery/02.jpg";
import jeland_j7_03 from "../images/cars/jeland_j7/gallery/03.jpg";
import jeland_j7_04 from "../images/cars/jeland_j7/gallery/04.jpg";
import jeland_j7_05 from "../images/cars/jeland_j7/gallery/05.jpg";
import jeland_j7_06 from "../images/cars/jeland_j7/gallery/06.jpg";
import jeland_j7_07 from "../images/cars/jeland_j7/gallery/07.jpg";
import jeland_j7_08 from "../images/cars/jeland_j7/gallery/08.jpg";
import jeland_j7_09 from "../images/cars/jeland_j7/gallery/09.jpg";

import j7_01 from "../images/cars/j7/gallery/01.jpg";
import j7_02 from "../images/cars/j7/gallery/02.jpg";
import j7_03 from "../images/cars/j7/gallery/03.jpg";
import j7_04 from "../images/cars/j7/gallery/04.jpg";
import j7_05 from "../images/cars/j7/gallery/05.jpg";
import j7_06 from "../images/cars/j7/gallery/06.jpg";
import j7_07 from "../images/cars/j7/gallery/07.jpg";

import j8_01 from "../images/cars/j8/gallery/01.jpg";
import j8_02 from "../images/cars/j8/gallery/02.jpg";
import j8_03 from "../images/cars/j8/gallery/03.jpg";
import j8_04 from "../images/cars/j8/gallery/04.jpg";
import j8_05 from "../images/cars/j8/gallery/05.jpg";
import j8_06 from "../images/cars/j8/gallery/06.jpg";
import j8_07 from "../images/cars/j8/gallery/07.jpg";

import j7_new_01 from "../images/cars/j7_new/gallery/01.jpg";
import j7_new_02 from "../images/cars/j7_new/gallery/02.jpg";
import j7_new_03 from "../images/cars/j7_new/gallery/03.jpg";
import j7_new_04 from "../images/cars/j7_new/gallery/04.jpg";
import j7_new_05 from "../images/cars/j7_new/gallery/05.jpg";
import j7_new_06 from "../images/cars/j7_new/gallery/06.jpg";
import j7_new_07 from "../images/cars/j7_new/gallery/07.jpg";

const DEFAULT_ADVANTAGES = [
  "<b>Удвоим выгоду за обмен авто</b>",
  "<b>Без первоначального взноса</b>",
  "КАСКО в подарок",
  "Комплект доп. оборудования в подарок",
  "Начислим бонусы на карту Автомир",
  "Подарок за Тест-Драйв",
  "Гарантия 5 лет",
];

const DEFAULT_OFFERS = [
  {
    icon: 'credit-card',
    text: '<b>Улучшим<br/> любое предложение</b>'
  },
  {
    icon: 'sign',
    text: 'Без наценки<br/> дилера'
  },
  {
    icon: 'sign',
    extra: 'extra',
    text: '<b style="color: #00647a;">Рассрочка<sup>*</sup></b>'
  }
];

const DEFAULT_BUTTONS = ["Узнать цену", "Рассчитать кредит"];

export default [
  {
    id: "jeland_j6_44",
    brand: "Jeland",
    new: false,
    name: "J6 4*4<br/> <small>(полный привод)</small>",
    benefit: "",
    // benefitText: "Лимитированная версия",
    advantages: [
      // 'Всего за 15 668 ₽/месяц*', 
      ...DEFAULT_ADVANTAGES
    ],
    offers: DEFAULT_OFFERS,
    cover: jeland_j644_cover,
    gallery: [jeland_j644_01, jeland_j644_02, jeland_j644_03, jeland_j644_04, jeland_j644_05, jeland_j644_06, jeland_j644_07],
    buttons: DEFAULT_BUTTONS,
  },
  {
    id: "jeland_j6",
    brand: "Jeland",
    new: false,
    name: "J6",
    benefit: "",
    // benefitText: "Лимитированная версия",
    advantages: [
      // 'Всего за 15 668 ₽/месяц*', 
      ...DEFAULT_ADVANTAGES
    ],
    offers: DEFAULT_OFFERS,
    cover: jeland_j6_cover,
    gallery: [jeland_j6_01, jeland_j6_02, jeland_j6_03, jeland_j6_04, jeland_j6_05, jeland_j6_06, jeland_j6_07, jeland_j6_08, jeland_j6_09],
    buttons: DEFAULT_BUTTONS,
  },
  {
    id: "jeland_j7",
    brand: "Jeland",
    new: false,
    name: "J7",
    benefit: "",
    // benefitText: "Лимитированная версия",
    advantages: [
      // 'Всего за 15 668 ₽/месяц*', 
      ...DEFAULT_ADVANTAGES
    ],
    offers: DEFAULT_OFFERS,
    cover: jeland_j7_cover,
    gallery: [jeland_j7_01, jeland_j7_02, jeland_j7_03, jeland_j7_04, jeland_j7_05, jeland_j7_06, jeland_j7_07, jeland_j7_08, jeland_j7_09],
    buttons: DEFAULT_BUTTONS,
  },
  {
    id: "j6",
    brand: "Jaecoo",
    new: false,
    name: "J6",
    benefit: "",
    // benefitText: "Лимитированная версия",
    advantages: [
      // 'Всего за 15 668 ₽/месяц*', 
      ...DEFAULT_ADVANTAGES
    ],
    offers: DEFAULT_OFFERS,
    cover: j6_cover,
    gallery: [j6_01, j6_02, j6_03, j6_04, j6_05, j6_06, j6_07, j6_08, j6_09],
    buttons: DEFAULT_BUTTONS,
    fuel_92: true,
  },
  {
    id: "j7_new",
    brand: "Jaecoo",
    new: false,
    name: "J7",
    benefit: "",
    // benefitText: "Лимитированная версия",
    advantages: [
      // 'Всего за 15 668 ₽/месяц*',
      ...DEFAULT_ADVANTAGES
    ],
    offers: DEFAULT_OFFERS,
    cover: j7_new_cover,
    gallery: [j7_new_01, j7_new_02, j7_new_03, j7_new_04, j7_new_05, j7_new_06, j7_new_07],
    buttons: DEFAULT_BUTTONS,
    fuel_92: true,
  },
  {
    id: "j8",
    brand: "Jaecoo",
    name: "J8",
    benefit: "",
    // benefit: "2 250 000",
    advantages: [
      // 'Всего за 13 148 ₽/месяц*', 
      ...DEFAULT_ADVANTAGES
    ],
    offers: DEFAULT_OFFERS,
    cover: j8_cover,
    gallery: [j8_01, j8_02, j8_03, j8_04, j8_05, j8_06, j8_07],
    buttons: DEFAULT_BUTTONS,
  },
  // {
  //   id: "j7",
  //   brand: "Jaecoo",
  //   name: "J7",
  //   benefit: "",
  //   // benefit: "2 250 000",
  //   advantages: [
  //     // 'Всего за 12 127 ₽/месяц*', 
  //     ...DEFAULT_ADVANTAGES
  //   ],
  //   offers: DEFAULT_OFFERS,
  //   cover: j7_cover,
  //   gallery: [j7_01, j7_02, j7_03, j7_04, j7_05, j7_06, j7_07],
  //   buttons: DEFAULT_BUTTONS,
  // }
];
